import { render, staticRenderFns } from "./StatisticsHeader.vue?vue&type=template&id=79591c9b&"
import script from "./StatisticsHeader.vue?vue&type=script&lang=js&"
export * from "./StatisticsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79591c9b')) {
      api.createRecord('79591c9b', component.options)
    } else {
      api.reload('79591c9b', component.options)
    }
    module.hot.accept("./StatisticsHeader.vue?vue&type=template&id=79591c9b&", function () {
      api.rerender('79591c9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/Statistics/Page/StatisticsHeader.vue"
export default component.exports